<style lang="scss" scoped>
.item {
  padding-top: 10px;
  .info {
    background-color: #fff;
    padding: 15px;
    border-color: #d7dde4;
    border-collapse: separate;
    border-style: solid;
    border-width: 1px 1px 0 1px;
    .right {
      float: right;
    }
    .i {
      width: 100px;
      display: inline-block;
    }
  }
}
</style>

<template>
  <div>
    <div class="tools">
      <i-input
        v-model="query"
        placeholder="请输入..."
        style="width: 200px"
      ></i-input>
      <i-button @click="load">查询</i-button>
    </div>
    <div class="item" v-for="row in source" :key="row.no">
      <div class="info">
        <span class="i">{{ row.no }}</span>
        <span class="i">{{ row.customerName }}</span>
        <span class="i">{{ row.customerPhone }}</span>
        <i-button v-if="row.state == '待审核'" @click="apply(row)">
          通过
        </i-button>
        &nbsp;
        <i-button v-if="row.state == '待审核'" @click="cancel(row.no)">
          驳回
        </i-button>
        <span style="padding-left: 100px">{{ row.note }}</span>
        <span class="right"
          >{{ row.saleName }} {{ row.state }} {{ row.createdAt }}</span
        >
      </div>
      <i-table highlight-row :columns="columns" :data="row.items"></i-table>
    </div>
    <page
      :total.sync="page.total"
      @on-change="pageChange"
      :style="{ 'margin-top': '10px', 'margin-left': '100px' }"
      :current.sync="page.current"
    ></page>
    <modal title="确认订单" v-model="showModal">
      <Date-picker
        type="date"
        placeholder="选择日期"
        style="width: 200px"
        v-model="createDate"
      ></Date-picker>
      <div slot="footer">
        <i-button @click="close">取消</i-button>
        <i-button type="primary" @click="ok">确认</i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  components: {},
  data() {
    return {
      showModal: false,
      createDate: '',
      targetNo: '',
      query: '',
      page: {
        total: 0,
        current: 1,
        pagesize: 10,
      },
      columns: [
        {
          title: '编码',
          key: 'categoryId',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          title: '数量',
          key: 'count',
        },
        {
          title: '价格',
          key: 'price',
        },
        {
          title: '合计',
          key: 'total',
        },
      ],
      source: [],
      currentRow: {},
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      let { current, pagesize } = this.page;

      this.$http
        .post('delivery/find', {
          name: this.query,
          ready: true,
          offset: (current - 1) * pagesize,
          limit: pagesize,
        })
        .then(({ data }) => {
          if (data.msg === 'ok') {
            this.source = data.rows;
            this.page.total = data.count;
          }
        });
    },
    pageChange() {
      this.load();
    },
    close() {
      this.showModal = false;
    },
    ok() {
      let no = this.targetNo;
      let createDate = this.createDate;
      if (no && createDate)
        this.$http
          .post('delivery/apply', {
            no,
            createDate,
          })
          .then(({ data }) => {
            if (data.msg === 'ok') {
              this.$Message.success('通过成功!');
              this.load();
              this.showModal = false;
            }
          });
    },
    apply(row) {
      let { no, createdAt } = row;
      let month = dayjs(createdAt).month();
      if (month === dayjs().month()) {
        console.log(no);
        this.$http
          .post('delivery/apply', {
            no,
          })
          .then(({ data }) => {
            if (data.msg === 'ok') {
              this.$Message.success('通过成功!');
              this.load();
            }
          });
      } else {
        this.targetNo = no;
        this.createDate = dayjs().format('YYYY-MM-DD');
        this.showModal = true;
      }
    },
    cancel(no) {
      this.$http
        .post('product/order/cancel', {
          no,
        })
        .then(({ data }) => {
          if (data.msg === 'ok') {
            this.$Message.success('驳回成功!');
            this.load();
          }
        });
    },
  },
};
</script>
